import React, { useState, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { TabSwitcher, Button } from "@ann/web-components";
import {
  SwitcherContainer,
  MenuWrapper,
  TabSwitcherContainerLeft,
  SwitcherContainerRight,
  DropdownMenu,
  DropdownItem,
  WorkFlowProcessContainer,
  CircularProgress
} from "./Switcher.styled";

const Switcher = ({ onTabChange, isWorkflowReady = true, triggerData = null }) => {
  const location = useLocation();
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Determine active tab based on current URL using useMemo
  const activeTab = useMemo(() => {
    const pathname = location.pathname;
    if (pathname.includes('/automation')) {
      return 'automation';
    } else if (pathname.includes('/logs')) {
      return 'logs';
    } else {
      return 'overview';
    }
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTabChange = (tabId) => {
    // Prevent navigation to automation tab if workflow is not ready
    if (tabId === "automation" && !isWorkflowReady) {
      return;
    }
    
    // setActiveTab(tabId); // This line is removed as per the new_code
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  const handleActionSelect = (action) => {
  
    setIsMenuOpen(false);
  };

  const getWorkflowTabLabel = () => {
    if (!isWorkflowReady && !triggerData?.externalFlowId) {
      return (
          <WorkFlowProcessContainer>
            <span>Workflow</span> <CircularProgress/>
          </WorkFlowProcessContainer>);
    } else if (!isWorkflowReady) {
      return "Workflow (Setting up...)";
    }
    return "Workflow";
  };

  return (
    <SwitcherContainer>
      <TabSwitcherContainerLeft>
        <TabSwitcher
          key={activeTab}
          defaultSelectedId={activeTab}
          size="medium"
          onChange={handleTabChange}
        >
          <TabSwitcher.Button id="overview" label="Overview" />
          <TabSwitcher.Button 
            id="automation" 
            label={getWorkflowTabLabel()}
            disabled={!isWorkflowReady}
          />
          <TabSwitcher.Button id="logs" label="Logs" />
        </TabSwitcher>
      </TabSwitcherContainerLeft>
      <SwitcherContainerRight>
        <MenuWrapper ref={menuRef} disabled={true}>
          <Button
            size="medium"
            type="secondary"
            label="Actions"
            iconRight="chevronDown"
            onClick={toggleMenu}
            disabled={true}
          />
          {isMenuOpen && (
            <DropdownMenu>
              <DropdownItem onClick={() => handleActionSelect("archive")}>
                Archive
              </DropdownItem>
              <DropdownItem onClick={() => handleActionSelect("share")}>
                Share
              </DropdownItem>
            </DropdownMenu>
          )}
        </MenuWrapper>
      </SwitcherContainerRight>
    </SwitcherContainer>
  );
};

export default Switcher;
